<template>
    <div>
        <el-table
                :data="tableData"
                :span-method="objectSpanMethod"
                :row-class-name="tableRowClassName"
                :header-cell-style="tableHeader"
                style="width: 100%"
                height="650">
            <el-table-column
                    v-for="(cont,index) in this.labelData"
                    :key="index"
                    :prop="cont.prop"
                    :label="cont.labels"
                    :fixed="cont.fixed"
                    :width="cont.width">
                <template slot-scope="scope" >
                    <pre class="pre">{{ scope.row[cont.prop] }}</pre>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    export default {
        name: "VDLCont",
        props: {
            fMes: {
                type: String,
                default: ' '
            }
        },

        data(){
            return {
                jsonData:[],
                tableData: [],
                labelData:[]
            }
        },
        methods:{
            objectSpanMethod({row, rowIndex, columnIndex }) {
                let mergeLength = 1;//需要进行横纵合并的列
                if (columnIndex < mergeLength) {
                    let finArray = [1,1];
                    // 处理行数据
                    let cgname = Object.keys(row)[columnIndex]

                    if(rowIndex === 0 || row[cgname] !== this.tableData[rowIndex-1][cgname]){
                        let rowspan = 1;
                        //计算需要进行合并操作的行
                        for(let i=0; i<this.tableData.length-1; i++){
                            // 只合并连续的
                            if(this.tableData[i][cgname] === row[cgname] && this.tableData[i+1][cgname] === row[cgname]){
                                rowspan ++;
                            }
                        }
                        finArray[0] = rowspan;
                    }else {
                        finArray[0] = 0;
                    }

                    // 处理列数据
                    let colkeys = Object.keys(row);
                    let cgvalue = Object.values(row)[columnIndex];
                    if(columnIndex ===0 || row[colkeys[columnIndex-1]] !== row[colkeys[columnIndex]]){
                        let colspan = 1;
                        //计算需要进行合并操作的列
                        for(let i=columnIndex; i<mergeLength; i++) {
                            // 只合并连续的
                            if (row[colkeys[i]]===cgvalue && row[colkeys[i+1]]===cgvalue && i+1<mergeLength) {
                                colspan ++;
                            }
                        }
                        finArray[1] = colspan;
                    } else {
                        finArray[1] = 0;
                    }

                    return finArray

                }
            },
            tableRowClassName({ rowIndex}) {
                if (rowIndex % 2 == 0) {
                    return 'black-row';
                } else {
                    return 'hui-row';
                }
            },
            tableHeader({ rowIndex}){
                if (rowIndex % 2 == 0) {
                    return 'black-row';
                } else {
                    return 'hui-row';
                }
                // return 'tableHeader'
            }
        },
        created() {
            let type = this.$route.params.type;
            let data = "";
            if (this.fMes  !== " "){
                data = require("../assets/JSON/"+this.fMes);
            }else{
                data = require("../assets/JSON/"+ type +".json");
            }
            this.jsonData = data;
            this.tableData = this.jsonData.tabData;
            this.labelData = this.jsonData.labData;
        },
        destroyed() {
            this.tableData = "";
            this.labelData = "";
            this.jsonData = "";
        }

    }

</script>

<style>
    .pre {
        font-family: AlibabaPuhuiTiR
    }

    .tableHeader{
        background: #000000;
        color: #ffffff;
    }
    .el-table .black-row {
        background: #000000;
        color: #ffffff;
    }

    .el-table .hui-row {
        background: #191919;
        color: #ffffff;
    }

    .el-table>>> tbody tr:hover>td,
    .el-table>>> tbody th:hover>td{
        background-color:#000000!important;
        color: #ffffff!important;
    }
    .el-table td, .el-table th.is-leaf{
        border-bottom: none;
    }
    .el-table__body tr:nth-child(odd).hover-row>td{
        background: #000000;
        color: #ffffff;
    }
    .el-table__body tr:nth-child(even).hover-row>td{
        background: #191919;
        color: #ffffff;
    }

    .el-table__fixed, .el-table__fixed-right{
        box-shadow: 0 0 10px rgb(180 180 180 / 50%);
    }
</style>